function getAPRSSymbolAddress(symbol) {
    // console.log('symbol: ', symbol)
    const tableSymbol = symbol.charAt(0);
    const table = 
        (tableSymbol === '/') ? 0 :
        ((tableSymbol === '\\' || /^[0-9A-Z]$/.test(tableSymbol)) ? 1 : 2);
    const search = symbol.charAt(1);
    let overlay = null;
    if (/^[0-9A-Z]$/.test(tableSymbol)) {
        overlay = tableSymbol;
    }
    const translation = [
        '!"#$%&\'()*+,-./0', '123456789:;<=>?@', 'ABCDEFGHIJKLMNOP', 'QRSTUVWXYZ[\\]^_`', 'abcdefghijklmnop', 'qrstuvwxyz{|}~'
    ];
    for (let row = 0; row < translation.length; row++) {
        const rowData = translation[row];
        for (let col = 0; col < rowData.length; col++) {
            if (rowData[col] === search) {
                // console.log(table, row, col);
                return [table, row, col, overlay];
            }
        }
    }
    return false;
}

function getAPRSSymbolImageTagByAddress(address, size = 24) {
    if (typeof address === 'undefined' || !Array.isArray(address) || address.length !== 4) {
        return false;
    }
    return "<i class=\"aprs-table" + address[0] + "-" + size + " aprs-address-" + size + "-" + address[1] + "-" + address[2] + "\" data-v-67fd7b5c=\"\"  ></i>";
}

function getAPRSSymbolImageTagByClass(address, size = 24) {
    if (typeof address === 'undefined' || !Array.isArray(address) || address.length !== 4) {
        return false;
    }
    let overlay_class = null;
    if (address[3]){
        let overlay_address = getAPRSSymbolAddress('/'+address[3]);
        // console.log('overlay_address: ', overlay_address)
        overlay_class=" aprs-table2-" + size + " aprs-address-ov-" + size + "-" + overlay_address[1] +"-" + overlay_address[2];
    } else {
        overlay_class="";
    }
    return "aprs-table" + address[0] + "-" + size + " aprs-address-" + size + "-" + address[1] + "-" + address[2] + overlay_class;
}

const getAPRSSymbolImageTag = (symbol, size = 24) => {
    const address = getAPRSSymbolAddress(symbol);
    return getAPRSSymbolImageTagByAddress(address, size);
}

const getAPRSSymbolImageClass = (symbol, size = 24) => {
    // console.log(symbol)
    if (symbol) {
        const address = getAPRSSymbolAddress(symbol)
        // console.log('address: ', address, 'size: ', size)
        return getAPRSSymbolImageTagByClass(address, size)
    }
}

export {getAPRSSymbolImageTag, getAPRSSymbolImageClass}
